import { render, staticRenderFns } from "./Ords.vue?vue&type=template&id=471e64d4&"
import script from "./Ords.vue?vue&type=script&lang=js&"
export * from "./Ords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports